module.exports = __webpack_public_path__ + "img/QRCode.49c42295.png";